import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { BoxV2, ButtonUI } from 'sonata-react-components';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import { MediaChannelSelector } from '../MediaChannelSelector/MediaChannelSelector';
import { MediaChannelSelectionStepStyled } from './MediaChannelSelectionStep.styled';

type State = {
  selectedMediaChanel: CampaignFamilyEnum;
};

type Props = {
  defaultValue: CampaignFamilyEnum;
  id: string;
  onSubmit: (value: CampaignFamilyEnum) => void;
  options: CampaignFamilyEnum[];
};

export const MediaChannelSelectionStep: React.VFC<Props> = ({ defaultValue, id, onSubmit, options }) => {
  const { formatMessage } = useIntl();
  const [{ selectedMediaChanel }, setState] = useState<State>({
    selectedMediaChanel: defaultValue
  });

  const handleChannelChange = (newValue: CampaignFamilyEnum) => {
    setState(prevState => ({
      ...prevState,
      selectedMediaChanel: newValue
    }));
  };

  return (
    <MediaChannelSelectionStepStyled className="mediaChannelSelectionStep" id={id}>
      <BoxV2.Body className="mediaChannelSelectionStep__container">
        <MediaChannelSelector
          id={`mediaChannelSelector-${id}`}
          onChange={handleChannelChange}
          options={options}
          subTitle={formatMessage({
            defaultMessage: 'Ensure a successful IO configuration by prioritizing the Media Channel selection.',
            id: 'mediaChannelSelection.creation.subtitle'
          })}
          title={formatMessage({
            defaultMessage: "Let's start by selecting the Media Channel for the Insertion Order",
            id: 'mediaChannelSelection.creation.title'
          })}
          value={selectedMediaChanel}
        />
      </BoxV2.Body>
      <ButtonUI
        className="mediaChannelSelectionStep__submitButton"
        icon="fa-solid fa-arrow-right"
        iconPosition="right"
        id={`submitButton-${id}`}
        onClick={() => onSubmit(selectedMediaChanel)}
        shape="squareRounded"
        text={formatMessage({
          defaultMessage: 'Go to Insertion Order settings',
          id: 'mediaChannelSelection.creation.button'
        })}
        type="secondary"
      />
    </MediaChannelSelectionStepStyled>
  );
};
